<template>
    <div class="filter-panel d-flex justify-content-between">
        <div class="filter-control" @click="onOpenCloseFilter">
            <div class="d-flex justify-content-between">
                <div>
                    <a href="javascript:void(0)" class="text-secondary"><b>Filtra risultati</b><span> | {{counter}}</span></a>
                </div>
                <div>
                    <button class="btn btn-sm btn-secondary mr-3" @click="onResetFilter">reset</button>
                </div>
            </div>
        </div>
        <div v-if="false && isFrom && isShowFlexibleDates" class="pl-3 flexible-date" v-show="foundFlexibleDates">
            <small>Date Flessibili?</small>
            <a href="javascript:void(0)" @click="onOpenDateFlessibili">scopri alternative</a>
        </div>
        <div @mouseleave="openFilter = false">
            <DropdownFilterFlight :value="filter" v-show="openFilter" :is-from="isFrom" @change="onChangeFilter"/>
        </div>
        <ModalFlexibleDates ref="modalFlexyDate" v-if="isShowFlexibleDates && foundFlexibleDates"/>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import DefaultModal from '../../../../../back/components/pages/layout/DefaultModal'
import DropdownFilterFlight from './dropdown/DropdownFilterFlight'
import ModalFlexibleDates from './modals/ModalFlexibleDates'

export default {
  name: 'FilterFlightPanel',
  components: {ModalFlexibleDates, DropdownFilterFlight, DefaultModal},
  props: {
    isFrom: {
      type: Boolean,
      default: true
    },
    isShowFlexibleDates: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      openFilter: false,
      openDateFlessibili: false,
      filter: this.getFilter()
    }
  },
  computed: {
    foundFlexibleDates: function () {
      return this.getFlexibleDates().length > 0
    },
    counter: function () {
      return this.isFrom ? this.getFlightsFrom().length : this.getFlightsTo().length
    }
  },
  methods: {
    ...mapGetters(['getFlightsFrom', 'getFlightsTo', 'getFlexibleDates', 'getFlightFilterFrom', 'getFlightFilterTo']),
    getFilter: function () {
      return this.isFrom ? this.getFlightFilterFrom() : this.getFlightFilterTo()
    },
    resetFilter: function () {
      this.$store.dispatch(this.isFrom ? 'resetFlightFilterFrom' : 'resetFlightFilterTo')
    },
    dispatchFilter: function (filter) {
      this.$store.dispatch(this.isFrom ? 'modifyFlightFilterFrom' : 'modifyFlightFilterTo', filter)
    },
    onOpenCloseFilter: function (event) {
      this.filter = this.getFilter()
      this.openFilter = !this.openFilter
      this.openDateFlessibili = false
    },
    onApplyFilter: function (event) {
      if (!this.openFilter) {
        this.openFilter = true
      } else {
        event.stopPropagation()
        this.openFilter = false
        this.dispatchFilter(this.filter)
      }
    },
    onOpenDateFlessibili: function () {
      this.openDateFlessibili = !this.openDateFlessibili
      this.openFilter = false
      this.$refs.modalFlexyDate.open()
    },
    onChangeFilter: function (filter) {
      this.filter = filter
      this.dispatchFilter(this.filter)
    },
    onResetFilter: function (event) {
      event.stopPropagation()
      this.resetFilter()
      this.filter = this.getFilter()
      this.openFilter = false
      this.openDateFlessibili = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/FilterFlightPanel.vue